import React from 'react'
import { Modal, Button, Radio } from 'antd'
import styles from './DeleteSectionModal.module.css'

const DeleteSectionModal = ({
    open,
    onCancel,
    onConfirm,
    deleteSectionData,
    deleteOption,
    setDeleteOption,
}) => {
    return (
        <Modal
            open={open}
            onCancel={onCancel}
            footer={null}
            closable={true}
            className={styles.deleteSectionModal}
            width={480}
            centered
        >
            <div className={styles.deleteSectionModalContent}>
                <h3 className={styles.deleteSectionModalTitle}>
                    Are you sure you want to delete this section?
                </h3>
                {deleteSectionData && (
                    <div className={styles.deleteSectionModalBody}>
                        <p className={styles.deleteSectionInfo}>
                            This section{' '}
                            <strong>{deleteSectionData?.sectionName}</strong>{' '}
                            includes {deleteSectionData?.totalTasks} task
                            {deleteSectionData?.totalTasks !== 1 ? 's' : ''}.
                        </p>
                        <Radio.Group
                            value={deleteOption}
                            onChange={(e) => setDeleteOption(e.target.value)}
                            className={styles.deleteSectionRadioGroup}
                        >
                            <Radio
                                value="keep"
                                className={styles.deleteSectionRadio}
                            >
                                Delete this section and keep this{' '}
                                {deleteSectionData?.totalTasks} task
                                {deleteSectionData?.totalTasks !== 1 ? 's' : ''}
                            </Radio>
                            <Radio
                                value="delete"
                                className={styles.deleteSectionRadio}
                            >
                                Delete this section and delete this{' '}
                                {deleteSectionData?.totalTasks} task
                                {deleteSectionData?.totalTasks !== 1 ? 's' : ''}
                            </Radio>
                        </Radio.Group>
                    </div>
                )}
                <div className={styles.deleteSectionModalFooter}>
                    <Button
                        onClick={onCancel}
                        className={styles.deleteSectionCancelButton}
                    >
                        Cancel
                    </Button>
                    <Button
                        type="primary"
                        danger
                        onClick={onConfirm}
                        className={styles.deleteSectionConfirmButton}
                    >
                        Delete section
                    </Button>
                </div>
            </div>
        </Modal>
    )
}

export default DeleteSectionModal
